import './ModerationHome.css'
import { IconSchool, IconUser } from '@tabler/icons-react'
import ViewCard from '../../../components/ViewCard/ViewCard'
import ModerationDashboard from '../ModerationDashboard/ModerationDashboard'
import { ROLE_SECTIONS } from '../../../utils/sidebarURLs'

export default function ModerationHome() {
   return (
      <section className='ModerationHome-main-container'>
         <div className='ModerationHome-grid-container'>
            {ROLE_SECTIONS.moderacion.items.map(item => {
               if(item.title === 'Dashboard') return
               return < ViewCard item={item} />
            })}
         </div>
         <ModerationDashboard/>
      </section>
   )
}